export default __webpack_public_path__ + "static/media/gym-img-02.e8db3ee7.jpg";